import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	loadingSync: false,
	mutating: false,
	error: null,
	mentionableStaff: [],
	loadingMentionableStaff: false,
	mentionableStaffError: null,
};

const studentNotesSlice = createSlice({
	name: 'studentNotes',
	initialState,
	reducers: {
		syncStudentNotesStart: (state) => {
			state.loadingSync = true;
			state.error = null;
		},
		syncStudentNotesSuccess: (state) => {
			state.loadingSync = false;
			state.error = null;
		},
		syncStudentNotesFailure: (state, { payload }) => {
			state.loadingSync = false;
			state.error = payload ?? 'No se pudieron sincronizar las notas.';
		},
		studentNoteMutationStart: (state) => {
			state.mutating = true;
			state.error = null;
		},
		studentNoteMutationSuccess: (state) => {
			state.mutating = false;
			state.error = null;
		},
		studentNoteMutationFailure: (state, { payload }) => {
			state.mutating = false;
			state.error = payload ?? 'No se pudo completar la acción.';
		},
		clearStudentNotesError: (state) => {
			state.error = null;
		},
		fetchMentionableStaffStart: (state) => {
			state.loadingMentionableStaff = true;
			state.mentionableStaffError = null;
		},
		fetchMentionableStaffSuccess: (state, { payload }) => {
			state.loadingMentionableStaff = false;
			state.mentionableStaff = Array.isArray(payload) ? payload : [];
			state.mentionableStaffError = null;
		},
		fetchMentionableStaffFailure: (state, { payload }) => {
			state.loadingMentionableStaff = false;
			state.mentionableStaffError = payload ?? 'No se pudo cargar el personal para etiquetar.';
		},
		clearMentionableStaff: (state) => {
			state.mentionableStaff = [];
			state.loadingMentionableStaff = false;
			state.mentionableStaffError = null;
		},
		resetStudentNotesState: () => initialState,
	},
});

export const {
	syncStudentNotesStart,
	syncStudentNotesSuccess,
	syncStudentNotesFailure,
	studentNoteMutationStart,
	studentNoteMutationSuccess,
	studentNoteMutationFailure,
	clearStudentNotesError,
	fetchMentionableStaffStart,
	fetchMentionableStaffSuccess,
	fetchMentionableStaffFailure,
	clearMentionableStaff,
	resetStudentNotesState,
} = studentNotesSlice.actions;

export default studentNotesSlice.reducer;
